export default __webpack_public_path__ + "people.bffd38695d4082d9.svg";